// extracted by mini-css-extract-plugin
export default {"activeSectionContainer":"ActiveSection_activeSectionContainer__BI6UX","contentForm":"ActiveSection_contentForm__2ERWb","buttons":"ActiveSection_buttons__jDYAv"};